export default __webpack_public_path__ + "static/media/section4litmatch1.a292fb73.gif";